import {
  BackendFormSchema,
  DynamicFormLayout,
  DynamicFieldConfig,
  UiSection,
  UiField,
  DataFlowRule,
} from '../models/dynamic-form.models';

// export function mapBackendSchema(schema: BackendFormSchema): DynamicFormLayout {
//   const sections: UiSection[] = schema.Ui.form.map((w) => w.section);

//   const fieldsMap: Record<string, DynamicFieldConfig> = {};

//   // start from backend Fields dto
//   schema.Fields.forEach((f) => {
//     fieldsMap[f.Name] = {
//       name: f.Name,
//       label: f.Label || f.Name,
//       type: f.Type,
//       category: f.Category,
//       required: f.IsRequired,
//       placeholder: f.Placeholder || '',
//       inputType: f.InputType || undefined,
//       options: f.Options as any,
//       dataSource: f.DataSource as any,
//       reference: f.Reference as any,
//       computedExpression:
//         f.ComputedExpression || (f as any).computed || undefined,

//       events: undefined,

//       parentField: f.ParentField || undefined, // ✅ FIX 1
//     };
//   });

//   // enrich with UI-level properties
//   sections.forEach((sec) =>
//     sec.rows.forEach((row) =>
//       row.fields.forEach((f: UiField) => {
//         const existing = fieldsMap[f.name];

//         const cfg: DynamicFieldConfig = existing ?? {
//           name: f.name,
//           label: f.label || f.name,
//           type: f.type,
//           category: (f.category as any) || 'dynamic',
//           required: !!f.required,
//           placeholder: f.placeholder,
//           inputType: f.inputType,
//           options: f.options,
//           dataSource: f.dataSource,
//           computedExpression: f.computed,
//           events: f.events,
//         };

//         cfg.events = f.events || cfg.events;
//         cfg.dataSource = f.dataSource || cfg.dataSource;
//         if (f.options) cfg.options = f.options;
//         if (f.computed) cfg.computedExpression = f.computed;

//         // Merge parentField (UI wins)
//         if (f.parentField) cfg.parentField = f.parentField; // ✅ FIX 3
//         if (!existing) fieldsMap[f.name] = cfg;
//       }),
//     ),
//   );

//   return {
//     entity: schema.Entity,
//     name: schema.Name,
//     viewMode: schema.ViewMode,
//     sections,
//     fieldsMap,
//   };
// }
// export function mapBackendSchema(schema: any): DynamicFormLayout {
//   // 1. Fix casing: 'ui' instead of 'Ui'
//   // Use optional chaining (?.) and provide an empty array as fallback
//   const sections: UiSection[] = schema?.ui?.form?.map((w: any) => w.section) || [];

//   const fieldsMap: Record<string, DynamicFieldConfig> = {};

//   // 2. Fix casing: 'fields' instead of 'Fields'
//   const backendFields = schema?.fields || [];

//   backendFields.forEach((f: any) => {
//     // 3. Fix internal property casing (f.name instead of f.Name)
//     fieldsMap[f.name] = {
//       name: f.name,
//       label: f.label || f.name,
//       type: f.type,
//       category: f.category,
//       required: !!f.isRequired, // Note: JSON has 'isRequired'
//       placeholder: f.placeholder || '',
//       inputType: f.inputType || undefined,
//       options: f.options,
//       dataSource: f.dataSource,
//       reference: f.reference,
//       computedExpression: f.computedExpression || undefined,
//       events: undefined,
//       parentField: f.parentField || undefined,
//     };
//   });

//   // Enrich with UI-level properties
//   sections.forEach((sec) =>
//     sec.rows.forEach((row) =>
//       row.fields.forEach((f: UiField) => {
//         const existing = fieldsMap[f.name];

//         const cfg: DynamicFieldConfig = existing ?? {
//           name: f.name,
//           label: f.label || f.name,
//           type: f.type,
//           category: (f.category as any) || 'dynamic',
//           required: !!f.required,
//           placeholder: f.placeholder,
//           inputType: f.inputType,
//           options: f.options,
//           dataSource: f.dataSource,
//           computedExpression: f.computed,
//           events: f.events,
//         };

//         cfg.events = f.events || cfg.events;
//         cfg.dataSource = f.dataSource || cfg.dataSource;
//         if (f.options) cfg.options = f.options;
//         if (f.computed) cfg.computedExpression = f.computed;

//         if (f.parentField) cfg.parentField = f.parentField;
//         if (!existing) fieldsMap[f.name] = cfg;
//       }),
//     ),
//   );

//   return {
//     // 4. Fix casing: 'entity' and 'name'
//     entity: schema?.entity,
//     name: schema?.name,
//     viewMode: schema?.viewMode,
//     sections,
//     fieldsMap,
//   };
// } 

export function mapBackendSchema(schema: any): DynamicFormLayout {
  // 1. Setup Base Collections with fallback safety
  const sections: UiSection[] = schema?.ui?.form?.map((w: any) => w.section) || [];
  const fieldsMap: Record<string, DynamicFieldConfig> = {};
  const backendFields = schema?.fields || [];

  // 2. Map existing flat fields from backend
  backendFields.forEach((f: any, index: number) => {

    fieldsMap[f.name] = {
      name: f.name,
      label: f.label || f.name,
      type: f.type,
      category: f.category,
      required: !!f.isRequired,

      placeholder: f.placeholder || '',
      inputType: f.inputType || undefined,

      options: f.options,
      dataSource: f.dataSource,

      reference: f.reference,

      computedExpression:
        f.computedExpression || undefined,

      events: undefined,

      parentField:
        f.parentField || undefined,

      validators:
        f.validators || undefined,

      visibleIf:
        f.visibility?.when,

      requiredWhen:
        f.requiredWhen,

      softMax:
        f.softMax,

      filter:
        f.filter,

      dialogWidth:
        f.dialogWidth,

      filterColumns:
        f.filterColumns,

      displaySource:
        f.displaySource,

      dependsOn:
        f.dependsOn,

      state:
        f.state,

      autoNumber:
        f.autoNumber,

      lineConfig:
        f.lineConfig,

      dateConfig:
        f.dateConfig,

      // IMPORTANT
     seq:
      f.seq && f.seq > 0
        ? f.seq
        : (index + 1)
    };
  });

  /**
   * Helper function to recursively extract fields, 
   * especially from within 'repeater' types.
   */
  const processFieldRecursive = (f: any,parentFieldName?: string,seq?: number) => {
    // If field doesn't exist in map (discovered in UI but not in flat list), create it
    if (!fieldsMap[f.name]) {
      fieldsMap[f.name] = {
        name: f.name,
        label: f.label || f.name,
        type: f.type,
        category: f.category || 'dynamic',
        required: !!f.required, // UI JSON uses required
        placeholder: f.placeholder || '',
        inputType: f.inputType,
        options: f.options,
        dataSource: f.dataSource,
        reference: f.reference,
        computedExpression: f.computed, // UI JSON uses computed
        events: f.events,
        parentField: f.parentField || parentFieldName,
        validators: f.validators,
        lineConfig: f.lineConfig,
        autoNumber: f.autoNumber,
        dateConfig: f.dateConfig,
        seq: seq ?? 0
      };
    } else {
      // If it exists, enrich it with UI-specific properties that might be missing in flat list
      const existing = fieldsMap[f.name];
      existing.events = f.events || existing.events;
      existing.dataSource = f.dataSource || existing.dataSource;
      existing.validators = f.validators || existing.validators;

      // 🔥 ENRICH EXISTING FIELDS IF UI HAS THESE PROPS
      existing.filter = f.filter ?? existing.filter;
      existing.dialogWidth = f.dialogWidth || existing.dialogWidth;
      existing.filterColumns = f.filterColumns || existing.filterColumns;
      if (seq) {
        existing.seq = seq;
      }

      if (f.computed) existing.computedExpression = f.computed;
      if (f.parentField || parentFieldName) {
        existing.parentField = f.parentField || parentFieldName;
      }
    }

    // CRITICAL FIX: If this is a repeater (like 'lines'), process its internal 'fields'
    if (
      f.type === 'repeater' &&
      Array.isArray(f.fields)
    ) {

      f.fields.forEach(
        (
          childField: any,
          index: number
        ) => {

          processFieldRecursive(
            childField,
            f.name,
            index + 1
          );

        }
      );
    }
  };

  // 3. Enrich and discover nested fields from the UI Sections
  sections.forEach((sec) => {
    sec.rows.forEach((row) => {
      row.fields.forEach((f: any) => {
        processFieldRecursive(f);
      });
    });
  });

  return {
    entity: schema?.entity,
    name: schema?.name,
    viewMode: schema?.viewMode,
    // 🔥 FIX: Check both 'moduleCode' and 'modulecode'
    moduleCode: schema?.moduleCode || schema?.modulecode,
    transType: schema?.transType || schema?.transtype,
    sections,
    fieldsMap,
    dataFlow: schema?.dataFlow || [],
    actions: schema?.actions || [],
    taxConfig: schema?.taxConfig || { enabled: false, mode: 'line', persist: false, inclusive: false, allowManual: false, headerSummary: false, header: { organizationField: '', customerField: '', currencyField: '', transactionType: '' }, line: { itemField: '', quantityField: '', priceField: '', taxGroupIdField: '', taxGroupNameField: '', taxAmountField: '', baseAmountField: '', grossAmountField: '', taxLinesField: '' }, summary: { subtotalField: '', taxTotalField: '', grandTotalField: '' } },
  };
}